"use strict";
// Copyright 2017-2018 Stratumn SAS. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants = __importStar(require("./const"));
var errors = __importStar(require("./errors"));
var link_1 = require("./link");
var chainscript_pb_1 = require("./proto/chainscript_pb");
/**
 * LinkBuilder makes it easy to create links that adhere to the ChainScript
 * spec.
 * It provides valid default values for required fields and allows the user
 * to set fields to valid values.
 */
var LinkBuilder = /** @class */ (function () {
    function LinkBuilder(process, mapId) {
        this.link = new chainscript_pb_1.stratumn.chainscript.Link();
        this.link.version = constants.LINK_VERSION;
        if (!process) {
            throw new TypeError("process is missing");
        }
        if (!mapId) {
            throw new TypeError("map id is missing");
        }
        this.link.meta = new chainscript_pb_1.stratumn.chainscript.LinkMeta();
        this.link.meta.clientId = constants.ClientId;
        this.link.meta.mapId = mapId;
        this.link.meta.outDegree = -1;
        this.link.meta.process = new chainscript_pb_1.stratumn.chainscript.Process();
        this.link.meta.process.name = process;
    }
    LinkBuilder.prototype.withAction = function (action) {
        this.link.meta.action = action;
        return this;
    };
    LinkBuilder.prototype.withData = function (data) {
        this.linkData = data;
        return this;
    };
    LinkBuilder.prototype.withDegree = function (d) {
        this.link.meta.outDegree = d;
        return this;
    };
    LinkBuilder.prototype.withMetadata = function (data) {
        this.linkMetadata = data;
        return this;
    };
    LinkBuilder.prototype.withParent = function (linkHash) {
        if (!linkHash || linkHash.length === 0) {
            throw new TypeError("link hash is missing");
        }
        this.link.meta.prevLinkHash = linkHash;
        return this;
    };
    LinkBuilder.prototype.withPriority = function (priority) {
        if (priority < 0) {
            throw new TypeError("priority needs to be positive");
        }
        this.link.meta.priority = priority;
        return this;
    };
    LinkBuilder.prototype.withProcessState = function (state) {
        var meta = this.link.meta;
        var process = meta.process;
        process.state = state;
        return this;
    };
    LinkBuilder.prototype.withRefs = function (refs) {
        var _a;
        var meta = this.link.meta;
        var newRefs = refs.map(function (ref) {
            if (!ref.process) {
                throw errors.ErrLinkProcessMissing;
            }
            if (!ref.linkHash || ref.linkHash.length === 0) {
                throw errors.ErrLinkHashMissing;
            }
            var pbRef = new chainscript_pb_1.stratumn.chainscript.LinkReference();
            pbRef.linkHash = ref.linkHash;
            pbRef.process = ref.process;
            return pbRef;
        });
        (_a = meta.refs).push.apply(_a, newRefs);
        return this;
    };
    LinkBuilder.prototype.withStep = function (step) {
        this.link.meta.step = step;
        return this;
    };
    LinkBuilder.prototype.withTags = function (tags) {
        var _a;
        var meta = this.link.meta;
        var newTags = tags.filter(function (t) { return t; });
        (_a = meta.tags).push.apply(_a, newTags);
        return this;
    };
    LinkBuilder.prototype.build = function () {
        var link = new link_1.Link(this.link);
        if (this.linkData) {
            link.setData(this.linkData);
        }
        if (this.linkMetadata) {
            link.setMetadata(this.linkMetadata);
        }
        return link;
    };
    return LinkBuilder;
}());
exports.LinkBuilder = LinkBuilder;
//# sourceMappingURL=link_builder.js.map